import React from 'react';
import PropTypes from 'prop-types';
import Formsy from 'formsy-react';

function SecureFormsy(props) {
  const { children, isSubForm } = props;
  if (isSubForm) {
    return <section>{children}</section>;
  }
  return <Formsy>{children}</Formsy>;
}

SecureFormsy.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  isSubForm: PropTypes.bool,
};

SecureFormsy.defaultProps = {
  isSubForm: false,
};

export default SecureFormsy;
